
const TextPaitentStyle = theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
    },
    modalWrapper: {
        outline: "none",
        height: 257,
        width: 570,
        left: 60,
        overflow: "hidden",
        position: "relative",
        border: "1px solid #979797",
        borderRadius: 4,
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#FFFFFF",
        boxShadow: "10px 10px 10px 0 rgba(0,0,0,0.5)"
    },
    modalHeader: {
        maxHeight: 24,
        display: "flex",
        flex: 1,
        backgroundColor: "#d2dcdd",
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: 16,
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "20px",
        paddingLeft: 13,
        alignItems: "center"
    },
    modalBody: {
        display: "flex",
        flex: 1,
        flexDirection: "column",
        paddingLeft: 18,
        paddingRight: 18,
        paddingTop: 20
    },
    contentWrapper: {
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap"
    },
    mainTitleText: {
        color: "#242424",
        width: "95px",
        fontSize: 14,
        fontFamily: "Proxima Nova",
        fontWeight: "bold",
        lineHeight: "30px",
        letterSpacing: "0"
    },
    errorMessage: {
        display: "flex",
        alignItems: "center",
        flexDirection: "inherit",
        fontSize: 12,
        marginRight: "33px",
        marginBottom: "20px",
        color: "red"
    },
    noErrorMessage: {
        display: "flex",
        alignItems: "center",
        flexDirection: "inherit",
        fontSize: 12,
        marginRight: "83px",
        marginBottom: "20px"
    },
    buttonStyle: {
        boxShadow: 'none',
        width: 150,
        height: 30,
        textTransform: 'none',
        fontSize: 16,
        lineHeight: "20px",
        padding: 0,
        marginRight: 20,
        fontWeight: "bold",
        backgroundColor: '#00ad50',
        fontFamily: "Proxima Nova",
        '&:hover': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:active': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:focus': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:disabled': {
            color: 'white',
            boxShadow: 'none',
        },
    },
    cancelButtonStyle: {
        boxShadow: 'none',
        width: 150,
        height: 30,
        textTransform: 'none',
        fontSize: 16,
        lineHeight: "20px",
        padding: 0,
        border: "1px solid #4d4d4d",
        color: "#242424",
        fontWeight: "bold",
        backgroundColor: 'white',
        fontFamily: "Proxima Nova",
        '&:hover': {
            backgroundColor: 'white',
            boxShadow: 'none',
        },
        '&:active': {
            backgroundColor: 'white',
            boxShadow: 'none',
        },
        '&:focus': {
            backgroundColor: 'white',
            boxShadow: 'none',
        },
    },
    modalActionWrapper: {
        display: "flex",
        flex: 1,
        justifyContent: "flex-end",
        alignItems: "flex-end",
        marginBottom: 15
    },
    modalCloseWrapper: {
        display: "flex",
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        marginRight: 21,
        marginBottom: 15
    },
    templateInput: {
        flexGrow: 1,
        height: 30,
        "& > div": {
            height: 30,
            border: "1px solid #979797",
            borderRadius: 3
        },
        "& fieldset": {
            display: "none"
        },
        "& div": {
            color: "#242424",
            fontFamily: "Proxima Nova",
            fontSize: "14px",
            letterSpacing: 0,
            backgroundColor: "white",
            lineHeight: "17px"
        },
        "& div:focus": {
            backgroundColor: "white !important",
        }
    },
    templateInputError: {
        width: 435,
        height: 30,
        "& > div": {
            height: 30,
            border: "1px solid red",
            borderRadius: 3
        },
        "& fieldset": {
            display: "none"
        },
        "& div": {
            color: "#242424",
            fontFamily: "Proxima Nova",
            fontSize: "14px",
            letterSpacing: 0,
            backgroundColor: "white",
            lineHeight: "17px"
        },
        "& div:focus": {
            backgroundColor: "white !important",
        }
    },
    menuItemWidth: {
        minWidth: 435,
        maxWidth: 435
    },
    menuItemList: {
        "& li": {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "inline-block",
            width: "100%"
        }
    },
    menuItemSelected: {
        backgroundColor: "#f3fdfd !important"
    },
    menuItemRoot: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        lineHeight: "17px"
    },
    productSelectStyle: {
        padding: 0,
        paddingLeft: 10
    },
    messageStyle: {
        height: 110,
        minHeight: 110,
        maxHeight: 110,
        maxWidth: 800,
        flexGrow: 1,
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        lineHeight: "17px",
        wordBreak: "break-word",
        whiteSpace: "pre-wrap",
        overflow: "auto"
    },
    extraContentWrapperStyle: {
        marginTop: 20,
        marginBottom: 40,
        alignItems: "flex-start !important"
    }
})

export default TextPaitentStyle;